import { createRoot, useEffect } from '@wordpress/element';
import { SnackbarList } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { store as noticesStore } from '@wordpress/notices';

import './style.scss';

import { RouterProvider, useLocation, useHistory } from './router';
import { Dashboard } from './dashboard';
import { Settings } from './settings';
import { Analytics } from './analytics';
import { getQueryArg } from '@wordpress/url';
import SettingsContextProvider from './context/settings-context';

const Router = () => {
	const history = useHistory();
	const { params } = useLocation();

	const menuRoot = document.querySelector( '#toplevel_page_popper' );
	const reset = () => {
		const page = getQueryArg( window.location.href, 'page' );
		if ( ! page ) {
			return;
		}
		for ( const child of menuRoot.querySelectorAll( 'a' ) ) {
			const target = getQueryArg( child.href, 'page' );
			if ( page === target ) {
				child.classList.add( 'current' );
				child.parentElement.classList.add( 'current' );
			} else {
				child.classList.remove( 'current' );
				child.parentElement.classList.remove( 'current' );
			}
		}
	};

	const handleChange = ( e ) => {
		e.preventDefault();

		if (
			'popper-pro-manage-license' === getQueryArg( e.target.href, 'page' )
		) {
			return ( window.location.href = e.target.href );
		}

		history.push( {
			page: getQueryArg( e.target.href, 'page' ),
			section: getQueryArg( e.target.href, 'section' ),
		} );
		reset();
	};

	useEffect( () => {
		reset();
		menuRoot.addEventListener( 'click', handleChange, false );

		return () => {
			document
				.querySelector( '#toplevel_page_popper' )
				.removeEventListener( 'click', handleChange );
		};
	}, [] );

	if ( 'popper-pro-manage-license' === params.page ) {
		return false;
	}
	if ( 'popper-settings' === params.page ) {
		return <Settings />;
	}
	if ( 'popper-analytics' === params.page ) {
		return <Analytics />;
	}
	return <Dashboard />;
};

const App = () => {
	return (
		<RouterProvider>
			<SettingsContextProvider>
				<Router />
				<Notifications />
			</SettingsContextProvider>
		</RouterProvider>
	);
};

function Notifications() {
	const notices = useSelect(
		( select ) => select( noticesStore ).getNotices(),
		[]
	);
	const { removeNotice } = useDispatch( noticesStore );
	const snackbarNotices = notices.filter(
		( { type } ) => type === 'snackbar'
	);

	return (
		<SnackbarList notices={ snackbarNotices } onRemove={ removeNotice } />
	);
}

window.addEventListener( 'DOMContentLoaded', () => {
	const domNode = document.getElementById( 'popper' );
	const root = createRoot( domNode );

	root.render( <App /> );
} );
